import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LanguageStep} from './language-pack.interface';

@Component({
    selector: 'step',
    templateUrl: 'step.component.html',
    styleUrls: ['step.component.scss']
})
export class StepComponent {
    @Input() step: number;
    @Input() info: StepInfo<any>;
    @Input() isDisabled = false;
    @Output() nextStep = new EventEmitter();
    @Output() editClicked = new EventEmitter();
    stepNumber(): string {
        return this.info.mode === StepMode.COMPLETE ? '' : '' + this.step;
    }
    isClosed(): boolean {
        return this.info.mode === StepMode.CLOSED;
    }
    isComplete(): boolean {
        return this.info.mode === StepMode.COMPLETE;
    }
    showContent(): boolean {
        return this.info.mode === StepMode.OPEN || this.info.mode === StepMode.EDIT;
    }
    showCancelEdit(): boolean {
        return this.info.mode === StepMode.EDIT;
    }
    editSelected() {
        this.info.mode = StepMode.EDIT;
        this.editClicked.emit();
    }
    continueClicked() {
        const success = this.info.continueClicked ? this.info.continueClicked() : true;
        if (success) {
            this.nextStep.emit();
        }
    }
}

export interface StepInfo<T extends LanguageStep = LanguageStep> {
    mode: StepMode;
    text?: T;
    continueClicked?: () => boolean;
}

export enum StepMode {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    EDIT = 'EDIT',
    COMPLETE = 'COMPLETE'
}
